import type { Stage } from '../types';
import { Mascot, stageMascots } from './mascots';
import { useLanguage } from '../i18n/context';
import { getUi } from '../i18n/ui';
import styles from '../App.module.css';

interface StageNavProps {
  stages: Stage[];
  active: string;
  onSelect: (id: string) => void;
  stageProgress: (stageId: string, itemCount: number) => number;
}

function percent(p: number): string {
  return `${Math.round(p * 100)}%`;
}

export function StageNav({ stages, active, onSelect, stageProgress }: StageNavProps) {
  const { locale } = useLanguage();
  const ui = getUi(locale);

  return (
    <nav className={styles.nav} aria-label={ui.stageNav.ariaLabel}>
      <div className={styles.navList}>
        {stages.map((stage) => {
          const progress = stageProgress(stage.id, stage.checklist.length);
          const isActive = stage.id === active;
          return (
            <button
              key={stage.id}
              type="button"
              className={`${styles.navButton} ${isActive ? styles.navButtonActive : ''}`}
              aria-pressed={isActive}
              onClick={() => onSelect(stage.id)}
            >
              <span className={styles.navTop}>
                <span className={styles.navMascot}>
                  <Mascot id={stageMascots[stage.id] ?? 'momo'} size={30} />
                </span>
                <span className={styles.navHeading}>
                  <span className={styles.navTitle}>{stage.title}</span>
                  <span className={styles.navWeeks}>{stage.weeks}</span>
                </span>
              </span>
              <span className={styles.navProgress} aria-hidden="true">
                <span className={styles.navProgressBar}>
                  <span
                    className={styles.navProgressFill}
                    style={{ width: percent(progress) }}
                  />
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
